import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { withFormattedCount } from 'src/commons/i18nEnums'

const TooltipTitle = ({ rowCount }: { rowCount: number }) => {
  const { t } = useTranslation()
  return (
    <span style={{ fontSize: 13, lineHeight: 1.25 }}>
      {`${t('virtualizedTable.tableLimit', withFormattedCount(rowCount))}. ${t(
        'virtualizedTable.useFiltersOrExport'
      )}.`}
    </span>
  )
}

interface IInfoTooltipProps {
  classes?: ClassNameMap
  rowCount: number
}

const InfoTooltip = ({ rowCount, classes = {} }: IInfoTooltipProps) => {
  return (
    <Tooltip
      title={<TooltipTitle rowCount={rowCount} />}
      placement="bottom"
      style={{ color: 'button.color', fontSize: 50, height: '24px', width: '24px' }}
      classes={classes}
    >
      <InfoIcon color="primary" data-testid="info-icon" />
    </Tooltip>
  )
}

export default InfoTooltip
